/* Dependencies
 ---------------------------------------------------------- */
import { Application } from 'wrapper6'

/* Modules
 ---------------------------------------------------------- */
import Navigation from 'modules/_navigation'
import ObjectFit from 'modules/_object-fit'
import Print from 'modules/_print'
import LazyLoad from 'modules/_lazy-load'
import Accordion from 'modules/_accordion'
import FeatureTables from 'modules/_feature-table'
import ArticleSliders from 'modules/_article-slider'
import Modals from 'modules/_modals'
import ArticleArchive from 'modules/_article-archive'
import QuoteSlider from 'modules/_quote-slider'
import HoverEffect from 'modules/_hover-effect'
import VideoModal from 'modules/_video-modal'
import CoverSliders from 'modules/_cover-slider'
import Sticky from 'modules/_sticky'
import FilterCars from 'modules/_filter-cars'
import LocalMenu from 'modules/_local-menu'
import GallerySlider from 'modules/_gallery-slider'
import Dealers from 'modules/_dealers'
import GalleryWidgets from './modules/_gallery-widgets'
import CssVars from './modules/_css-vars'
import ListSection from './modules/_list-section'
import TextImageVariant from './modules/_text-image-variant'
import PriceTable from "modules/_price-table";
import ProductShowcase from "./modules/_product-showcase";

/* Vendor
 ---------------------------------------------------------- */

/* Setup
 ---------------------------------------------------------- */
const app = window.app = new Application(window.options || {})

/* Services
 ---------------------------------------------------------- */

/* Register services
 ---------------------------------------------------------- */

/* Run polyfills
 ---------------------------------------------------------- */
require('./polyfills/_closest')
require('./polyfills/_for-each')
require('./polyfills/_includes')

/* Register modules
 ---------------------------------------------------------- */
app.use(Navigation)
app.use(ObjectFit)
app.use(Print)
app.use(LazyLoad)
app.use(Accordion)
app.use(FeatureTables)
app.use(ArticleSliders)
app.use(Modals)
app.use(ArticleArchive)
app.use(QuoteSlider)
app.use(HoverEffect)
app.use(VideoModal)
app.use(CoverSliders)
app.use(Sticky)
app.use(FilterCars)
app.use(LocalMenu)
app.use(GallerySlider)
app.use(Dealers)
app.use(GalleryWidgets)
app.use(CssVars)
app.use(ListSection)
app.use(TextImageVariant)
app.use(PriceTable)
app.use(ProductShowcase)

// require('./app');
